import { cn } from "@/lib/utils";

import FileIcon from "./FileIcon";

const size = {
  sm: {
    icon: "size-5",
    text: "text-[4.5px] bottom-0.5",
  },
  md: {
    icon: "size-10",
    text: "text-xs bottom-1",
  },
};

const extensionsColor = {
  pdf: "bg-error-600",
  mp4: "bg-[#155EEF]",
  jpg: "bg-primary-600",
  jpeg: "bg-primary-600",
  png: "bg-primary-600",
  xls: "bg-green-600",
  xlsx: "bg-green-600",
  csv: "bg-green-600",
};

export default function FileTypeIcon(props: {
  size?: "sm" | "md";
  extension?: string;
}) {
  return (
    <div className="relative flex justify-center">
      <FileIcon
        className={cn(size[props.size || "md"].icon, "fill-gray-600")}
      />
      <span
        className={cn(
          "absolute -end-1 rounded-[2px] px-[3px] py-0.5 font-bold text-white",
          extensionsColor[props.extension as keyof typeof extensionsColor] ||
            "bg-gray-600",
          size[props.size || "md"].text,
        )}
      >
        {props.extension}
      </span>
    </div>
  );
}
